module.exports = __webpack_public_path__ + "static/img/81-3.e6c046a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/81-3.jpg
// module id = i+/7
// module chunks = 0